/**
 * Four cards. Where the section is wide enough they share the row; below that it scrolls
 * with the fourth card cut off at the edge to say there is more, and deliberately has no
 * arrows. A rendering cap, not a page size: the preview reads the drawer's first page from
 * the store and fetches nothing of its own.
 */
export const PREVIEW_REVIEW_COUNT = 4;
